export default __webpack_public_path__ + "static/char-v-11-151041f3355942e9f0906339e8b66491.mp4";